export default __webpack_public_path__ + "static/media/google.34b280c5.svg";